import BaseService from "./BaseService";

export default class EnturmacaoService extends BaseService {

  constructor(self) {
    super(self);
  }

  ListarDisciplinasDoAluno(parameters) {
      return this.ExecutaFetch("/api/Enturmacao/ListarDisciplinasDoAluno", "POST", parameters);
  }

  ListarDisciplinaGradeEquivalente(parameters) {
      return this.ExecutaFetch("/api/Enturmacao/ListarDisciplinaGradeEquivalente", "POST", parameters);
  }

  InserirDisciplina(parameters) {
      return this.ExecutaFetch("/api/Enturmacao/InserirDisciplina", "POST", parameters);
  }

  ListarDisciplinaAluno(parameters) {
      return this.ExecutaFetch("/api/Enturmacao/ListarDisciplinaAluno", "POST", parameters);
  }

  ExcluirDisciplina(parameters) {
      return this.ExecutaFetch("/api/Enturmacao/ExcluirDisciplina", "POST", parameters);
  }
}